// extracted by mini-css-extract-plugin
module.exports = {"test":"_1fe_S-","blue":"_7Jou5-"};